import { Component, OnInit } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../lib/api.service';
import { StorageService } from '../../../lib/storage.service';
import { LogService } from '../../../lib/log.service';
import { User } from '../../../models/user';
import { UserService } from '../../../lib/user.service';
import { Addiction } from '../../../models/addiction'
import { TranslateService } from '@ngx-translate/core';
import { config } from '../../../../environments/all';
import { ModalService } from 'app/lib/modal.service';
import { SchedulerModal } from 'app/components/scheduler-modal/scheduler-modal.component';

import * as _ from 'lodash';
import { AnalyticEvent } from 'app/lib/analytic-event';

@Component({
	templateUrl: './addiction-listing.html',
	styleUrls: ['./addiction-listing.scss']
})
export class AddictionListingPage implements OnInit {

	isLoaded: boolean;
	headerText: string;
	backText: string;
	activityschedules: Addiction[];
	loaded1 = false;
	loaded2 = false;
	loaded3 = false;
	isFrench = false;
	user: User;
	title: string;
	backLink = '/app/practice';
	back: string;

	constructor(
		private api: ApiService,
		private storage: StorageService,
		private log: LogService,
		private userService: UserService,
		private translate: TranslateService,
		private modalService: ModalService,
		private router: Router
	) {
		this.isLoaded = false;
		this.user = this.userService.getUser();
		this.title = 'Addiction & substance abuse';
	}

	ngOnInit() {


		this.translate.stream('addiction').subscribe((res: any) => {
			this.title = res.title;
			this.back = res.back;
		});
		//this.refresh();
	}

	refresh() {
		this.isLoaded = false;
		this.api.get('practice/addiction/listing', { 'UserID': this.user.id }).subscribe(
			(result: any) => {
				this.activityschedules = Addiction.initializeArray(result.data);
				this.log.event(AnalyticEvent.event.addictionListionLoaded);
			},
			(error: any) => {
				this.log.error('Error getting addiction results. ' + error.message);
			},
			() => {
				this.isLoaded = true;
			}
		);

	}

	loadMore() {


	}

	openAS() {
		this.modalService.showComponent(SchedulerModal, {}).afterClosed().subscribe(result => {
			this.refresh();
		});
	}

	navigate(id: number) {
		this.router.navigateByUrl('/app/practice/addiction/' + id);
	}

	delete(id) {
		this.modalService.showConfirmation("Delete", "Are you sure you want to delete your addiction entry?").afterClosed().subscribe(result => {
			if (result) {
				this.api.delete('practice/' + id).subscribe(
					(result: any) => {
						let index = _.findIndex(this.activityschedules, { id: id });
						this.activityschedules.splice(index, 1);
					},
					(error: any) => {
						this.log.error('Error deleting. ');
					}
				);
			}
		});
	}

}
